import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Smile } from "lucide-react";

interface ReactionPickerProps {
  onReaction: (emoji: string) => void;
}

const REACTIONS = [
  { emoji: "👍", label: "Thumbs up" },
  { emoji: "❤️", label: "Heart" },
  { emoji: "😂", label: "Laughing" },
  { emoji: "👏", label: "Clapping" },
  { emoji: "🎉", label: "Party" },
  { emoji: "🔥", label: "Fire" },
  { emoji: "👀", label: "Eyes" },
  { emoji: "💯", label: "100" },
];

export default function ReactionPicker({ onReaction }: ReactionPickerProps) {
  return (
    <Popover>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="shrink-0"
              aria-label="Open reactions"
            >
              <Smile className="h-4 w-4" />
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent side="top">Share a quick reaction</TooltipContent>
      </Tooltip>
      <PopoverContent className="w-auto p-2" align="end">
        <div className="grid grid-cols-4 gap-2">
          {REACTIONS.map((reaction) => (
            <Tooltip key={reaction.emoji}>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="sm"
                  className="text-2xl h-12 w-12 p-0 hover:scale-125 transition-transform"
                  onClick={() => onReaction(reaction.emoji)}
                  aria-label={`Send ${reaction.label} reaction`}
                >
                  {reaction.emoji}
                </Button>
              </TooltipTrigger>
              <TooltipContent side="top">{reaction.label}</TooltipContent>
            </Tooltip>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
